import { render, staticRenderFns } from "./ArticleLayout.vue?vue&type=template&id=5643c45a&scoped=true&"
import script from "./ArticleLayout.vue?vue&type=script&lang=js&"
export * from "./ArticleLayout.vue?vue&type=script&lang=js&"
import style0 from "./ArticleLayout.vue?vue&type=style&index=0&id=5643c45a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5643c45a",
  null
  
)

export default component.exports